<template>
  <div class="PreviewWindowsEdge">
      <div class="Icon" :style="{'backgroundImage': 'url(' + base.icon + ')'}"></div>
      <div class="Details">
        <div class="Title" ref="title" v-html="base.title"></div>
        <div class="Body" ref="body" v-html="base.body"></div>
        <div class="Info">{{base.domain}} &bullet; {{$t('via')}} Microsoft Edge</div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'PreviewWindowsEdge',
  props: {
    base: Object,
    override: Object
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped lang="less">
  .PreviewWindowsEdge {
    width: 364px;
    min-height: 100px;
    user-select: none;
    position: relattive;
    border: 1px solid #dedede;
    font-family: 'Open Sans', sans-serif;
    background-color: #2e79a6;
    color: #fff;
    position: relative;
    font-size: 13px;
  }
  .Icon {
    width: 48px;
    height: 48px;
    position: absolute;
    top: 24px;
    left: 16px;
    background-size: contain;
    background-position: center center;
    background-image: url('../assets/icon-windows-edge-badge.png');
    background-repeat: no-repeat;
  }
  .Details {
    margin-left: 80px;
    margin-top: 24px;
    width: 250px;

    .Title {
      font-weight: bold;
      max-height: 35px;
      overflow: hidden;
      margin-bottom: 5px;
    }
    .Body {
      font-weight: 100;
      max-height: 75px;
      overflow: hidden;
      margin-bottom: 10px;
      line-height: 150%;
      color: #ddd;
    }
    .Info {
      font-size: 11px;
      margin-bottom: 20px;
      color: #ddd;
    }
  }
</style>
